import * as React from 'react';
import * as Moment from 'moment';

import { getHeaderElement, getHeaderText } from './structure_tool_header';
import { compareSelect } from '../../../core/table/helpers/sortMethod';
import { convertHTMLJSON } from './HtmlConverters';
import { convertJSON2REACT } from './ReactConverters';
import { CellInfo } from 'react-table-6';
import { i18n } from '../../../i18n/i18n';
import { WArchivIcon } from '../../../core/elements/WArchivIcon';
import { formatDynamic } from './format_dynamic';
import { generateExcelFilter } from '../../table/filter/GenerateExcelFilter';
import { generateDatumFilter } from '../../table/filter/WTableFilterDatum';
import { generateVorhandenFilter } from '../../table/filter/GenerateVorhandenFilter';
import { filterMethodFulltext } from './filter_method_fulltext';
import { StructureTool } from './structure_tool';

// ***************************************************************************************************************
// HIER SCHEINT ALLES OBSOLETE ZU SEIN ***************************************************************************
// ***************************************************************************************************************

export function renderBeispiel(value: String): JSX.Element {
    if (!value) {
        return <></>;
    }
    return <div
        style={{ marginTop: '3px', backgroundColor: '#EEE', color: '#888', fontStyle: 'italic', padding: '2px', boxSizing: 'border-box' }}
    >
        <div style={{ fontSize: '8px', color: '#AAA' }}> Bsp.:</div>
        {value}
    </div>;
}

export function makeColumns(structure_tool: StructureTool, entity: string, atts: ReadonlyArray<any>, hiddenColumns: ReadonlyArray<string>, showingColumns: ReadonlyArray<string>,
    examples: any,
    filterModes?: any, getdata?: () => ReadonlyArray<any>,
    customFormatter?: (field: string, value: any, data?: any, row?: any) => any, showEntitiesInHeader?: boolean, bundle?: any,
    customFilterTranslator?: (key: string, value: string) => string, summaryCondition?: (row: any) => boolean) {
    const columns = new Array<any>();
    const formatter_euro = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
    });
    const formatter_dez2 = new Intl.NumberFormat('de-DE', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    let cnt = 0;
    atts.forEach((att: any) => {
        if (att.TYPE === 'TITEL' || att.TYPE === 'COMBINATION') {      // Brauchen wir nur für Formulare
            return;
        }
        let formatterUsed: any = null; // Hier schreiben wir den Formatter rein, als merker für den Footer
        const header = getHeaderElement(entity, att, showEntitiesInHeader);
        const header_text = getHeaderText(entity, att);
        // const header = att.NAME;
        const item: any = {
            accessor: att.KEY,
            Header: header,
            HeaderText: header_text,
            type: att.TYPE,
            format: att.FORMAT,
            show: true,
            excel_export: att.EXCEL_EXPORT,
            escape_0: att.ESCAPE_0
        };
        if (showingColumns && showingColumns.indexOf(att.KEY) >= 0) {
            item.show = true;
            item.show_orig = true;
        } else if ((att.HIDDEN && (+att.HIDDEN === 1 || att.HIDDEN === true)) ||
            (hiddenColumns && hiddenColumns.indexOf(att.KEY) >= 0) ||
            (hiddenColumns && hiddenColumns.indexOf('_ALL') >= 0) ||
            (att.VISIBLE !== undefined && att.VISIBLE === false) ||
            !structure_tool.hasAttRecht(att)) {
            item.show = false;
            item.show_orig = false;
        }
        if (att.WIDTH) {
            item.width = att.WIDTH;
        }
        if (typeof att.FIELD_GROUP === 'string' && att.FIELD_GROUP !== '') {
            item.field_group = att.FIELD_GROUP;
        }
        //
        const typ = structure_tool.resolveType(att.TYPE, att.OPTS, att);
        if (typ === 'textselect' || typ === 'select') {
            item.sortMethod = compareSelect;
        }
        // Hier zuerst für IMAGES
        // console.log(header_text + ' - ' , att.FILEMODE);
        if (att.TYPE === 'FILE' || (att.FILEMODE && att.FILEMODE === 'ARCHIV')) {
            const cell = (row: CellInfo) => {
                if (row.value && +row.value > 0) {
                    return (
                        <WArchivIcon
                            archivId={+row.value}
                            hideFilename={true}
                            module={structure_tool.modul}
                        />
                    );
                } else {
                    if (typeof row.value === 'string') { // Für Gesamtexport, falls hier ein Dateiname steht
                        return row.value;
                    }
                    return '';
                }
            };
            item.Cell = cell;
        } else if (att.TYPE === 'DATE') {
            const cell = (row: CellInfo) => {
                if (customFormatter) {
                    const value_formatted = customFormatter(att.KEY, row.value, row.original, row);
                    if (value_formatted !== row.value) {
                        return value_formatted;
                    }
                }
                const value = row.value && row.value !== '' && +row.value > 0 ? Moment.unix(row.value).format('DD.MM.YYYY') : '';
                return value;
            };
            item.Cell = cell;
        } else if (att.TYPE === 'CHECKBOX') {
            const cell = (row: CellInfo) => {
                // console.log('structure_tool cellfunction DATE row : ');
                // console.log(row);
                const value_orig = row.value;
                let value: any = customFormatter ? customFormatter(att.KEY, row.value, row.original, row) : row.value;
                if (value === value_orig) {
                    value = row.value && (row.value === 1 || +row.value === 1 || row.value === true) ? 'Ja' : 'Nein';
                }
                return value;
            };
            item.Cell = cell;
        } else if (att.TYPE === 'FIX') {
            const cell = (row: CellInfo) => att.CONTENT;
            item.Cell = cell;
        } else if (att.TYPE === 'FORMULA') {
            if (att.FORMAT === 'EURO') {
                formatterUsed = formatter_euro;
            } else if (att.FORMAT === 'DEZIMAL(2)') {
                formatterUsed = formatter_dez2;
            } else {
                formatterUsed = undefined;
            }
            const cell = (row: CellInfo) => {
                const value_raw = isNaN(row.value) || !formatterUsed ? row.value : formatterUsed.format(row.value);
                const value = customFormatter ? customFormatter(att.KEY, value_raw, row.original, row) : value_raw;
                return value;
            };
            item.Cell = cell;
        } else if (att.TYPE === 'DOUBLE') {
            const cell = (row: CellInfo, forExport?: boolean) => {
                const value_raw = row.value;
                let value = value_raw;
                if (att.FORMAT && att.FORMAT === 'EURO') {
                    value = typeof value_raw === 'number' ? formatter_euro.format(value_raw) : '';
                }
                if (att.FORMAT && att.FORMAT === 'DEZIMAL(2)') {
                    value = typeof value_raw === 'number' ? formatter_dez2.format(value_raw) : '';
                }
                value = customFormatter ? customFormatter(att.KEY, value_raw, row.original, row) : value;
                if (att.FORMAT_DYNAMIC) {
                    value = formatDynamic(att.FORMAT_DYNAMIC, value, value_raw, forExport);
                }
                return value;
            };
            formatterUsed = formatter_euro;
            item.Cell = cell;
        } else if (att.TYPE.startsWith('CHAR') && att.FORMAT && att.FORMAT === 'FARBE') {
            const cell = (row: CellInfo) => {
                const color = row.value && row.value !== '' ? row.value : 'transparent';
                const border = color === 'transparent' ? 0 : '1px solid black';
                return <div
                    style={{
                        width: 50, height: 30, display: 'inline-block',
                        border, backgroundColor: color
                    }}
                />;
            };
            item.Cell = cell;
        } else if ((att.TYPE === 'TEXT' || att.TYPE === 'LONGTEXT') && att.FORMAT && att.FORMAT === 'RICHTEXT') {
            const cell = (row: CellInfo) => {
                const json = convertHTMLJSON(row.value);
                const comp = convertJSON2REACT(json);
                return <div>
                    {/* <div style={{fontWeight: 'revert', fontStyle: 'revert'}}
                dangerouslySetInnerHTML={{ __html: row.value }}
                /> */}
                    {comp}
                </div>;
            };
            item.Cell = cell;
        } else if (att.TYPE === 'PERCENT') {
            const cell = (row: CellInfo, forExport?: boolean) => {
                const value_raw = row.value;
                let value = value_raw;
                if (typeof value === 'number' && att.FORMAT === 'DEZIMAL(2)') {
                    value = formatter_dez2.format(value);
                }

                value += ' %';

                if (customFormatter) {
                    value = customFormatter(att.KEY, value, row.original, row);
                }
                if (att.FORMAT_DYNAMIC) {
                    value = formatDynamic(att.FORMAT_DYNAMIC, value, value_raw, forExport);
                }
                return value;
            };
            formatterUsed = (att.FORMAT === 'DEZIMAL(2)' ? formatter_dez2 : undefined);
            item.Cell = cell;
        } else if (att.TYPE === 'DATETIME') {
            const cell = (row: CellInfo) => {
                // console.log('structure_tool cellfunction DATETIME row : ');
                const value_raw = row.value > 0 ? Moment.unix(row.value).format('DD.MM.YYYY HH:mm:ss') : '';
                const value = customFormatter ? customFormatter(att.KEY, value_raw, row.original, row)
                    : value_raw;
                return value;
            };
            item.Cell = cell;
        } else if (att.OPTS && att.OPTS instanceof Array) { // Wenn wir fixe Options haben
            const opts: Array<any> = att.OPTS;
            const cell = (row: CellInfo) => {
                // console.log('OPTS: ', opts, row);
                const value_found = opts.find((e: any) => e.VALUE + '' === row.value + '' ||
                    e.TITEL + '' === row.value + ''); // TODO FIXME
                // sollte eigentlich nicht erforderlich sein
                const value_raw = value_found ? value_found.TITEL : '';
                const value = customFormatter ? customFormatter(att.KEY, value_raw, row.original, row)
                    : value_raw;
                return value;
            };
            item.Cell = cell;
        } else {
            if (att.OPTS && bundle && bundle[att.KEY]) {
                att.OPTS.bundle = bundle[att.KEY]; // Dreckig das Bundle ins Att zu schreiben
                // .. geht aber nicht anders
            }
            const cell = (row: CellInfo, forExport?: boolean) => {
                let item_rendered = row.value;
                const opts_condition = !att.OPTS || !att.OPTS.OUTPUT_CONDITION ||
                    (row.original && row.original[att.OPTS.OUTPUT_CONDITION]);
                if (att.OPTS && att.OPTS.OUTPUT && att.OPTS.bundle && row.original && opts_condition) {
                    if (row.original) {
                        // if (row.original[att.KEY + '_orig']) {
                        //     const value_orig = row.original[att.KEY + '_orig'];
                        //     item_rendered = this.renderOptsItem(att.OPTS.bundle, att, value_orig);
                        // } else {
                        //     // console.log('No row.original-value: ', row);
                        // }
                        //
                        // Bei "Wirtschaftszweig / Tätigkeitsprofil" mit Multi-OUTPUTs, kann bezeichnung_2003 leer sein, dabei ist wz_tid_orig nicht vorhanden.
                        // "KEY": "wz_tid",
                        // "INPUT": "bezeichnung_2003",
                        // "OUTPUT": ["B:WZ 2003:", "code_2003", "bezeichnung_2003", "\n", "B:WZ 2008:", "code_2008", "bezeichnung_2008"],
                        const value_orig = row.original.hasOwnProperty(`${att.KEY}_orig`) ? row.original[`${att.KEY}_orig`] : row.original[`${att.KEY}`];
                        item_rendered = renderOptsItem(att.OPTS.bundle, att, value_orig);
                    } else {
                        // console.log('No row.original: ', row);
                    }
                }
                if (att.MODE && att.MODE === 'PASSWORD') {
                    return (<i style={{ color: '#AAA' }}> *** keine Anzeige *** </i>);
                }
                let value = customFormatter ? customFormatter(att.KEY, item_rendered, row.original, row) :
                    item_rendered;
                if (value === 0 && att.ALLOW_ZERO !== true) {
                    return '';
                }
                if (att.FORMAT_DYNAMIC) {
                    value = formatDynamic(att.FORMAT_DYNAMIC, value, row.value, forExport);
                }
                return value;
            };
            item.Cell = cell;
        }
        if (att.SUMMARY) {
            if (att.SUMMARY === 'SUM') {
                item.Footer = (rows: any) => {
                    // console.log('structure_tool makeColumns forEach att.SUMMARY === SUM : ');
                    // console.log(rows);
                    const valres = rows.data.reduce((total: number, value: any) => {
                        const val = Number(value._original[att.KEY]);
                        const condition: boolean = typeof summaryCondition === 'function' && !summaryCondition(value) ? false : true;
                        return total + (!isNaN(val) && condition ? val : 0);
                    }, 0);
                    if (att.FORMAT === 'EURO') {
                        formatterUsed = formatter_euro;
                    } else if (att.FORMAT === 'DEZIMAL(2)') {
                        formatterUsed = formatter_dez2;
                    } else {
                        formatterUsed = undefined;
                    }
                    if (formatterUsed) {
                        return formatterUsed.format(valres) + (att.SUMMARY_UNIT ? ' ' + att.SUMMARY_UNIT : '');
                    } else {
                        return valres + (att.SUMMARY_UNIT ? ' ' + att.SUMMARY_UNIT : '');;
                    }
                };
            }
            if (att.SUMMARY === 'COUNT') {
                item.Footer = (rows: any) => {
                    console.log('structure_tool makeColumns forEach att.SUMMARY === COUNT : ');
                    console.log(rows);
                    const valres = rows.data.reduce((total: number, value: any) => {
                        const val = value._original[att.KEY];
                        if (val && val !== '') {
                            return total === 0 ? 1 : total + 1;
                        }
                        return total;
                    }, 0);
                    if (formatterUsed) {
                        return formatterUsed.format(valres);
                    } else {
                        return valres;
                    }
                };
            } else
                if (att.SUMMARY === 'COUNT_POSITIV') {
                    item.Footer = (rows: any) => {
                        const valres = rows.data.reduce((total: number, value: any) => {
                            const val = value._original[att.KEY];
                            const valNum = Number(val);
                            if ((!isNaN(valNum) && valNum > 0) ||
                                (typeof value === 'boolean' && value === true) ||
                                ((value + '').toLowerCase() === 'wahr') ||
                                ((value + '').toLowerCase() === 'true') ||
                                ((value + '').toLowerCase() === 'ja')) {
                                return total === 0 ? 1 : total + 1;
                            } else {
                                return total;
                            }
                        }, 0);
                        if (formatterUsed) {
                            return formatterUsed.format(valres);
                        } else {
                            return valres;
                        }
                    };
                } else
                    if (att.SUMMARY === 'COUNT_DISTINCT') {
                        item.Footer = (rows: any) => {
                            const seen: any = {};
                            const valres = rows.data.reduce((total: number, value: any) => {
                                const val: string = 'dummy_' + value._original[att.KEY];
                                if (seen[val]) {
                                    return Object.keys(seen).length;
                                } else {
                                    seen[val] = 1;
                                    return Object.keys(seen).length;
                                }
                            }, 0);
                            if (formatterUsed) {
                                return formatterUsed.format(valres);
                            } else {
                                return valres;
                            }
                        };
                    }
            // item.Footer = (row: any) => {console.log(row.data); return 'x'; };
        }
        if (item.show) {
            if (cnt === 0 && att.TYPE !== 'DATE') {
                // Sticky blockiert den Datepicker.
                item.className = 'sticky';
                item.headerClassName = 'sticky';
            }
            const bsp = renderBeispiel(examples ? examples[att.KEY] : undefined);
            addCustomFilter(item, filterModes, bsp, getdata, att, customFilterTranslator);
            columns.push(item);
            cnt++;
        }
    });
    return columns;
}

export function addCustomFilter(item: any, filterModes: any, beispiel: JSX.Element, getdata: () => ReadonlyArray<any>, att: any,
    customFilterTranslator?: (key: string, value: string) => string) {
    if (att.FILTER_MODE || (filterModes && filterModes.hasOwnProperty(item.accessor))) {
        const mode: string = filterModes && filterModes.hasOwnProperty(item.accessor) ? filterModes[item.accessor] : att.FILTER_MODE;
        if (mode.toLowerCase() === 'excel') {
            const stamp = new Date().getTime();
            const excelFilter = ({ filter, onChange }: { filter: any, onChange: any }) =>
                generateExcelFilter(item.accessor, onChange, beispiel, getdata, att, item.className, stamp);
            const excelFilterMethod = (filter: any, row: any) => {
                return (filter.value.indexOf(row[item.accessor] + '') !== -1);
            };
            item.Filter = excelFilter;
            item.filterMethod = excelFilterMethod;
            return;
        } else if (mode.toLowerCase() === 'datum' || mode.toLowerCase() === 'datum_range') {
            const datumFilter = ({ filter, onChange }: { filter: any, onChange: any }) =>
                generateDatumFilter('range', beispiel, onChange);
            const datumFilterMethod = (filter: any, row: any) => {
                const stamp = parseInt(row[item.accessor], 10);
                if (filter.value) {
                    const von = filter.value.von;
                    const bis = filter.value.bis;
                    if (von > 0 && bis > 0) {
                        return (stamp >= von && stamp <= bis);
                    }
                }
                return true;
            };
            item.Filter = datumFilter;
            item.filterMethod = datumFilterMethod;
            return;
        } else
            if (mode.toLowerCase() === 'vorhanden') {
                const vorhandenFilter = ({ filter, onChange }: { filter: any, onChange: any }) =>
                    generateVorhandenFilter(item.accessor, beispiel, onChange, item);
                const vorhandenFilterMethod = (filter: any, row: any) => {
                    const value = row[item.accessor];
                    // console.log('Filter NV', filter, value);
                    if (value !== undefined && value !== null && value !== '' && value !== 0) {
                        console.log('Value vorhanden', value);
                        if (filter.value.showVorhanden) {
                            return true;
                        }
                    } else {
                        // console.log('Value NOT vorhanden', value);
                        if (filter.value.showNotVorhanden) {
                            return true;
                        }
                    }
                    return false;
                };
                item.Filter = vorhandenFilter;
                item.filterMethod = vorhandenFilterMethod;
                return;
            }

    }
    item.Filter = ({ filter, onChange }: { filter: any, onChange: any }) => {
        return <div> <input
            style={{ width: '100%' }}
            type='text'
            placeholder={i18n('Suchbegriff eingeben', 'sys')}
            value={filter ? filter.value : ''}
            onChange={(evt: any) => onChange(evt.target.value)} />
            {beispiel}
        </div>;
    };
    item.filterMethod = (filter: any, row: any) => filterMethodFulltext(filter, row,
        item.accessor, customFilterTranslator); // Siehe helpers
}
function renderOptsItem(bundle_data: Array<any>, att: any, value: any) {
    // console.log('renderOptsItem:', bundle_data, att, value);
    const identifier = att.OPTS.IDENTIFIER;
    const bundle_item = bundle_data.find((item: any) => item[identifier] === value);
    if (bundle_item) {
        let parts = '';
        att.OPTS.OUTPUT.forEach((f: any) => { parts += (bundle_item[f] ? bundle_item[f] : '-') + ' '; });
        return parts.trim();
    }
    return null;
}